import { Skeleton } from "@/components/ui/skeleton";

export function SectionSkeleton() {
  return (
    <div className="py-20 bg-deep-navy">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header Skeleton */}
        <div className="text-center mb-16 space-y-4">
          <Skeleton className="h-12 w-3/4 mx-auto bg-cyan/10" />
          <Skeleton className="h-6 w-2/3 mx-auto bg-cyan/5" />
        </div>

        {/* Content Grid Skeleton */}
        <div className="grid md:grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="space-y-4">
              <Skeleton className="h-48 w-full rounded-lg bg-cyan/10" />
              <Skeleton className="h-6 w-3/4 bg-cyan/5" />
              <Skeleton className="h-4 w-full bg-cyan/5" />
              <Skeleton className="h-4 w-5/6 bg-cyan/5" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="p-6 bg-deep-navy border border-cyan/20 rounded-lg space-y-4">
      <Skeleton className="h-12 w-12 rounded-full bg-cyan/10" />
      <Skeleton className="h-6 w-3/4 bg-cyan/5" />
      <Skeleton className="h-4 w-full bg-cyan/5" />
      <Skeleton className="h-4 w-5/6 bg-cyan/5" />
      <Skeleton className="h-10 w-32 mt-4 bg-cyan/10" />
    </div>
  );
}

export function TestimonialSkeleton() {
  return (
    <div className="py-20 bg-deep-navy">
      <div className="max-w-7xl mx-auto px-6">
        <Skeleton className="h-12 w-1/2 mx-auto mb-16 bg-cyan/10" />
        <div className="grid md:grid-cols-2 gap-8">
          {[1, 2].map((i) => (
            <div key={i} className="p-8 bg-cyan/5 border border-cyan/20 rounded-lg space-y-4">
              <Skeleton className="h-20 w-full bg-cyan/10" />
              <div className="flex items-center gap-4 mt-6">
                <Skeleton className="h-12 w-12 rounded-full bg-cyan/10" />
                <div className="space-y-2 flex-1">
                  <Skeleton className="h-4 w-32 bg-cyan/5" />
                  <Skeleton className="h-3 w-48 bg-cyan/5" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
